import React, { Suspense } from 'react';

export const UploadComponent = React.lazy(() => import('./Upload'));

export const Upload = () => (
  <Suspense fallback={null}>
    <UploadComponent />
  </Suspense>
);
